<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      item-key="id"
      :options.sync="tableOptions"
      :server-items-length="totalItems"
      :items-per-page="5"
      :headers="headerTable"
      :items="items"
      sort-by="name"
      @input="$emit('update:selected', $event)"
      :footer-props="footerTable"
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      :loading="loading"
      disable-sort
    >
      <template v-slot:[`item.classTitle`]="{ item }">
        <router-link style="text-decoration: none" :to="`/class/${$_get(item, 'class.id')}`">
          {{ $_get(item, 'class.title', '-') }}
        </router-link>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ item.date | ddmmyyyy }}
      </template>
      <template v-slot:[`item.isMakeup`]="{ item }">
        <span v-if="item.isMakeup">{{ item.makeupDate | ddmmyyyy }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:[`item.notes`]="{ item }">
        {{ item.notes }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex justify-end">
          <v-btn class="elevation-0" icon @click="() => onOpenDetailDialog(item)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon color="primary">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title style="cursor: pointer" @click="() => onRemove(item)"> Xoá </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
    <VacationDetailDialog ref="detail-dialog" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import get from 'lodash-es/get'
import VacationDetailDialog from './VacationDetailDialog.vue'

export default {
  components: { VacationDetailDialog },
  data: () => ({ tableOptions: {} }),
  computed: {
    ...mapState('scheduleVacation', ['totalItems', 'items', 'pageText', 'loading', 'searchParams']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số lịch nghỉ mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
    headerTable() {
      return [
        { text: 'Ngày nghỉ', value: 'date' },
        { text: 'Lớp', value: 'classTitle' },
        { text: 'Ngày học bù', value: 'isMakeup', align: 'center' },
        { text: 'Ghi chú', value: 'notes' },
        { text: 'Thao tác', value: 'actions', align: 'end' },
      ]
    },
  },
  methods: {
    ...mapActions({
      requestPageSettings: 'scheduleVacation/requestPageSettings',
      remove: 'scheduleVacation/remove',
      search: 'scheduleVacation/search',
    }),
    getColorIsMakeup(val = false) {
      return val ? 'success' : 'error'
    },
    getTextIsMakeup(val = false) {
      return val ? 'Có học bù' : 'Không học bù'
    },
    onOpenDetailDialog(item = {}) {
      this.$refs['detail-dialog'].openDialog(item.id)
    },
    onRemove(item = {}) {
      let hint = ''
      if (item.isMakeup) hint = 'Xoá lịch nghỉ đồng thời cũng xoá luôn buổi học bù của lớp. '
      this.$dialog.confirm({
        title: `Xóa lịch nghỉ ${this.$options.filters.ddmmyyyy(item.date)} của lớp ${get(item, 'class.title', '-')}`,
        text: hint + 'Bạn có chắc chắn muốn xóa lịch nghỉ?',
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.remove(item.id)
            this.$alert.success('Xoá thành công')
            await this.search({})
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>
